<template>
    <dialog-form
        ref="form"
        :value="value"
        @input="$emit('input', $event)"
        :title="$localize('SendOrderConfirmation.title')"
        @commit="save"
        :allow-continue="false"
        :loading="loading"
        loading-skeleton="list-item-avatar-two-line@4, list-item-two-line, image"
        :action-text="
            $localize('SendOrderConfirmation.button.sendOrderConfirmation')
        "
        action-icon="mdi-email-send"
    >
        <select-address
            v-if="data.relationId"
            :relation-id="data.relationId"
            v-model="addressId"
        />
        <send-email-form
            v-model="data.email"
            :relation-id="data.relationId"
            :contact-id="data.contactId"
            @nav="nav"
        />
        <template v-slot:actions-right>
            <v-btn class="mt-3" @click="downloadExample">
                Voorbeeld
                <v-icon class="red--text">mdi-adobe-acrobat</v-icon>
            </v-btn>
        </template>
    </dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import SendEmailForm from '../components/steps/SendEmailForm'
import { isGuid } from '@/services/validation'
import SelectAddress from '@/main/components/forms/SelectAddress'
import sendCommand from '@/services/sendCommand'
import {
    prepareOrderConfirmationEmail,
    getExampleOrderConfirmation,
} from '@/services/api'
import Vue from 'vue'

export default {
    components: { DialogForm, SendEmailForm, SelectAddress },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        projectId: {
            validator: isGuid,
        },
    },
    data() {
        return {
            data: {},
            addressId: null,
            saving: false,
            loading: false,
        }
    },
    async created() {
        this.loading = true
        const { result, ok } = await prepareOrderConfirmationEmail.call({
            args: { projectId: this.projectId },
        })
        if (ok) {
            this.data = result
        }
        this.loading = false
    },
    methods: {
        async save(callback) {
            const result = await sendCommand('SendOrderConfirmation', {
                projectId: this.projectId,
                addressId: this.addressId,
                email: this.data.email,
            })

            if (result.success) {
                this.$emit('saved')
            }

            callback({ success: result.success })
        },
        nav(to) {
            this.$emit('input', false)
            Vue.nextTick(() => {
                this.$router.push(to)
            })
        },
        downloadExample() {
            if (!this.$refs.form.$refs.form.validate()) {
                return
            }
            var downloadUrl = getExampleOrderConfirmation.create({
                projectId: this.projectId,
            }).url
            downloadUrl += `?addressId=${this.addressId}`
            window.location = downloadUrl
        },
    },
}
</script>
